import { render } from "./BACPayment.vue?vue&type=template&id=1c4537ce&scoped=true"
import script from "./BACPayment.vue?vue&type=script&lang=js"
export * from "./BACPayment.vue?vue&type=script&lang=js"

import "./BACPayment.vue?vue&type=style&index=0&id=1c4537ce&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c4537ce"]])

export default __exports__